export const CREATE_PLAN_TABS = {
  serviceFees: 'serviceFees',
  tierAndVolumePricing: 'tierAndVolumePricing',
  promotions: 'promotions',
} as const;

export type CreatePlanTab = (typeof CREATE_PLAN_TABS)[keyof typeof CREATE_PLAN_TABS];
